module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "lightest bold d-flex p-1 pointer bg-medium",
    on: {
      "click": function($event) {
        return _vm.expandPaymentClick()
      }
    }
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v("\n            " + _vm._s(_vm.paymentTitle(_vm.payment)) + "\n        ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.payment.code))]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [(_vm.isExpanded == true) ? _c('i', {
    staticClass: "fas fa-chevron-up"
  }) : _c('i', {
    staticClass: "fas fa-chevron-down"
  })])])]), _vm._v(" "), (_vm.isExpanded == true) ? _c('div', {
    staticClass: "bg-faded border-light p-2"
  }, [_c('pay-in-area', {
    attrs: {
      "payment": _vm.payment,
      "reservation": _vm.reservation,
      "readOnly": true
    },
    on: {
      "change": function($event) {
        return _vm.changed()
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7566fdd0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabPayments/expandedArea/historyPayment.vue
// module id = 1757
// module chunks = 0